import { render, staticRenderFns } from "./SerahTerimaGadai.vue?vue&type=template&id=24736cdc&scoped=true&"
import script from "./SerahTerimaGadai.vue?vue&type=script&lang=js&"
export * from "./SerahTerimaGadai.vue?vue&type=script&lang=js&"
import style0 from "./SerahTerimaGadai.vue?vue&type=style&index=0&id=24736cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24736cdc",
  null
  
)

export default component.exports